import { render, staticRenderFns } from "./hs-block.vue?vue&type=template&id=1cc1b00f&scoped=true&"
import script from "./hs-block.vue?vue&type=script&lang=js&"
export * from "./hs-block.vue?vue&type=script&lang=js&"
import style0 from "./hs-block.vue?vue&type=style&index=0&id=1cc1b00f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cc1b00f",
  null
  
)

export default component.exports